import { resolveHTTP } from '@/services/api'

const Api = resolveHTTP('/bl/authorizations')

Api.decline = (authorization) => {
  return Api.resource.post(`/decline/${authorization.id}`)
}

Api.approve = (authorization) => {
  return Api.resource.post(`/authorize/${authorization.id}`)
}

export default Api



// WEBPACK FOOTER //
// ./src/services/api/bl-authorizations.js